import Tooltip from './Tooltip';

export default Tooltip;


//////////////////
// WEBPACK FOOTER
// /Users/shuai/Documents/github/ant-design-pro-site/scaffold/node_modules/_rc-tooltip@3.7.3@rc-tooltip/es/index.js
// module id = 735
// module chunks = 0